// extracted by mini-css-extract-plugin
export default {"wrap":"LoginInput_wrap__+P5mW","inputBox":"LoginInput_inputBox__HhLHR","label":"LoginInput_label__2I4sb","input":"LoginInput_input__+5HOQ","error":"LoginInput_error__ZD9CL"};